import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { environment } from '@environments/environment';
import { ChangelogViewMarkViewedResponse, ChangelogViewUnseenResponse } from 'lfx-pcc';
import { Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PCCService {
  public unseenChangelogCount: WritableSignal<number> = signal(0);

  private pccServiceAPI = environment.apiV2URL + '/pcc-services';
  private urls = {
    changelog: `${this.pccServiceAPI}/changelog`,
  };

  private http: HttpClient = inject(HttpClient);

  public constructor() {}

  public clearCache(cacheNames: string[], params?: HttpParams): Observable<void> {
    return this.http.post<void>(`${this.pccServiceAPI}/clear-cache`, cacheNames, { params });
  }

  public fetchUnseenChangelogCount(): Observable<ChangelogViewUnseenResponse> {
    const params = new HttpParams().set('productId', environment.changelogProductId);
    return this.http
      .get<ChangelogViewUnseenResponse>(`${this.urls.changelog}/unseen`, { params })
      .pipe(tap((res) => this.unseenChangelogCount.set(res.data.unseenCount)));
  }

  public markChangelogViewed(): Observable<ChangelogViewMarkViewedResponse> {
    return this.http
      .post<ChangelogViewMarkViewedResponse>(`${this.urls.changelog}/mark-viewed`, { productId: environment.changelogProductId })
      .pipe(tap(() => this.unseenChangelogCount.set(0)));
  }
}
